import { SubdivisionAuditCreatableInterface } from '../interfaces/subdivision-audit-creatable.interface';
import { SubdivisionAuditDto } from './subdivision-audit.dto';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';

export class SubdivisionAuditCreateDto
  extends IntersectionType(
    PickType(SubdivisionAuditDto, [
      'subdivisionId',
      'actionType',
      'changedByUserId',
      'name',
      'address1',
      'city',
      'state',
      'zip',
      'builderId',
      'regionId',
      'active',
      'reqBumpoutTimesheet',
      'garageCostFixed',
      'dwHangingCostPerBoard',
      'dwFinishingCostPerBoard',
      'dwSprayingCostPerBoard',
      'dwpHangingCostPerBoard',
      'dwpFinishCostPerBoard',
      'dwpPrimeCostPerSqft',
      'dwpBump1CostPerBoard',
      'dwpTrim1CostPerSqft',
      'dwpInteriorPaintCostPerSqft',
      'dwpBump2CostPerBoard',
      'dwpTrim2CostPerSqft',
      'dwpFinalPaintCostPerSqft',
      'dwpBump3CostPerBoard',
      'dwpCMBluetapeCostPerSqft',
      'dwpFinalBluetapeCostPerSqft',
      'phaseStructureType',
      'specialJobsPercentage',
      'pieceworkPercentage',
      'highCeilingPerBoard',
      'screwInspectionPerBoard',
      'warrantyStatus',
      'interiorOptionsPercentage',
      'exteriorOptionsPercentage',
      'trimOptionPercentage',
    ]),
    PartialType(
      PickType(SubdivisionAuditDto, [
        'changeReason',
        'address2',
        'archived',
        'overrideRegionCostPerBoard',
        'overrideType',
        'allowPayoutAmountEditing',
      ]),
    ),
  )
  implements SubdivisionAuditCreatableInterface {}
